import { Component } from "react";
import { registerForLocalization, provideLocalizationService } from "@progress/kendo-react-intl";

/**
 * Komponenta pro validaci balíku na základě naskenovaného čárového kódu
 *
 * @class CheckBalikFromCiarovyKod
 * @extends {Component}
 */
class CheckBalikFromCiarovyKod extends Component {
    componentDidMount() {
        var response = this.validateZadanyKod();
        this.props.getResponse(response);
    }

    validateZadanyKod() {
        var localizationService = provideLocalizationService(this);

        var result = { zadanyKod: this.props.cisloCiarovehoKodu, errorMessage: null, isError: false };

        var patt = new RegExp("/D");
        if (patt.test(result.zadanyKod)) {
            result.errorMessage = localizationService
                .toLanguageString("clsPríjem.Neplatný kód balíka <P1> (musia to byť len číslice) !", "Neplatný kód balíka <P1> (musia to byť len číslice) !")
                .replace("<P1>", result.zadanyKod);
            result.isError = true;
            return result;
        }

        if (!result.zadanyKod || (result.zadanyKod.length == 13 && result.zadanyKod.substr(0, 1) != "0" && result.zadanyKod.substr(0, 1) != "8")) {
            result.errorMessage = localizationService.toLanguageString("clsPríjem.Neplatný kód balíka !", "Neplatný kód balíka !");
            result.isError = true;
            return result;
        }

        return result;
    }

    render() {
        return null;
    }
}

export default CheckBalikFromCiarovyKod;

registerForLocalization(CheckBalikFromCiarovyKod);



// WEBPACK FOOTER //
// ./src/components/common/SnimanieCiarovehoKodu/CheckBalikFromCiarovyKod.js